import React, { useEffect, useState } from "react";
import {
  useSearchParams,
	Link 
} from "react-router-dom";
import styles from './tutor.module.css';
import '../css/main-style.css';
import {getData, postData} from '../middleware/apiMiddleware';
import {setGeneralStorage, getGeneralStorage} from '../middleware/dataStorage';
import {modifiedDate} from '../middleware/dateControl';
import { useNavigate, useParams } from "react-router-dom";
import {Image} from 'react-bootstrap';
import edit from'../asset/edit.png';
import {Form} from 'react-bootstrap';
import SmallCalendar from '../components/SmallCalendar';
import OneOnOne from '../components/OneOnOne';
import RegClass from '../components/RegClass';
import TutorDetail from '../components/TutorDetail';
import MyTooltip from '../components/Utilities/MyTooltip';
import {CheckboxSmall} from '../components/Utilities/MyCheckbox';


export default function Tutor() {
	const navigate = useNavigate();
	let params = useParams();
  let tutorId = params.tutorId;
	
	let defaultToggle = getGeneralStorage('tutorPanelToggle') ?? 1;
	
	const [toggleStatus, setToggleStatus] = useState(defaultToggle);
	
	const [tutorGroups, setTutorGroups] = useState(false);
	
	const [rawData, setRawData] = useState({
		zoomLink:"", displayName:"", profilePic:"https://ehla-media-bucket.s3.ap-southeast-1.amazonaws.com/teacher_profic/VIP.jpg",username:"", tutorCourses:[], tutorCoursesNoZoom:[]});
	
	const [syllabusData, setSyllabusData] = useState([]);
	
	const [show, setShow] = useState(false);
	
	const [rawUpdateData, setUpdateRawData] = useState({
		id:null, title:"",syllabusId:1,advLessonType:"PDF"
	});
	
	const [updateData, setUpdateData] = useState({
		id:null, title:"",syllabusId:1,advLessonType:"PDF"
	});
	
	const fetchData = () => {		
		getData('syllabus/listSyllabusTopicAll', navigate)
		.then(res => {
				setSyllabusData(res.data);
			}
		);
		
		getData('tutorApi/listOneOnOne?tutorId=' + tutorId, navigate)
		.then(res => {
				res.data.forEach((v)=> {
					v.zooms = v.zooms.sort(function(a,b){
						return new Date(a.zStartDate) - new Date(b.zStartDate);
					});
				});
				
				
				
				setTutorGroups(res.data);
			}
		);
		
		
		getData('tutorApi/getTutorById?tutorId=' + tutorId, navigate)
		.then(res => {
				let tutorCourses = [];
				let tutorCoursesNoZoom = [];
			
				res.data.tutorCourses.forEach((v) => {
					if (v.latestZoomStartDate) {
						tutorCourses.push(v);
					} else {
						tutorCoursesNoZoom.push(v);
					}
				})
			
				setRawData({
					zoomLink: res.data.zoomLink,
					displayName: res.data.displayName,
					profilePic: res.data.profilePic,
					username: res.data.username,
					tutorCourses: tutorCourses,
					tutorCoursesNoZoom: tutorCoursesNoZoom,			
					
				});
			}
		);
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	
	const updateTutorCourse = async (tutorCourseId, data) => {
		
		
		let obj = {
			'tutorCourseId' : tutorCourseId,
			'title' : data.title,
			'syllabusId' : data.syllabusId,
			'advLessonType' : data.advLessonType,
			'defaultNeedEvaluation' : data.defaultNeedEvaluation,
		}
		await postData("tutorApi/updateTutorCourse", obj, navigate); 
		
		let tmpTutorCourses = rawData.tutorCourses;
		let tmpTutorCoursesNoZoom = rawData.tutorCoursesNoZoom;
		
		tmpTutorCourses.forEach((v) => {
			if (v.id == tutorCourseId) {
				v.title = data.title;
				v.syllabusId = data.syllabusId;
				v.advLessonType = data.advLessonType;
			}
		});
		
		tmpTutorCoursesNoZoom.forEach((v) => {
			if (v.id == tutorCourseId) {
				v.title = data.title;
				v.syllabusId = data.syllabusId;
				v.advLessonType = data.advLessonType;
			}
		});
		
		setRawData((prev)=>({...prev,
			['tutorCourses']: tmpTutorCourses,
			['tutorCoursesNoZoom']: tmpTutorCoursesNoZoom})
		);
		
		setShow(false);
	}
	const createTutorCourse = async (tutorId, data) => {
		let obj = {
			'tutorId' : tutorId,
			'title' : data.title,
			'syllabusId' : data.syllabusId,
			'advLessonType' : data.advLessonType,
			'defaultNeedEvaluation' : data.defaultNeedEvaluation,
		}
		await postData("tutorApi/createTutorCourse", obj, navigate); 
		
		getData('tutorApi/getTutorById?tutorId=' + tutorId, navigate)
		.then(res => {
				let tutorCourses = [];
				let tutorCoursesNoZoom = [];
			
				res.data.tutorCourses.forEach((v) => {
					if (v.latestZoomStartDate) {
						tutorCourses.push(v);
					} else {
						tutorCoursesNoZoom.push(v);
					}
				})
			
				setRawData({
					zoomLink: res.data.zoomLink,
					displayName: res.data.displayName,
					profilePic: res.data.profilePic,
					username: res.data.username,
					tutorCourses: tutorCourses,
					tutorCoursesNoZoom: tutorCoursesNoZoom,								
				});
			}
		);
		setShow(false);
	}
	
	const TutorCourseModal = (props) => {		
	
		const [rawCurData] = useState({
			tutorCourseId:props.raw.id,
			title:props.raw.title,
			syllabusId:props.raw.syllabusId,
			advLessonType:props.raw.advLessonType,			
			defaultNeedEvaluation:props.raw.defaultNeedEvaluation,			
		});
	
		const [updateData, setUpdateData] = useState(
			{
				title:props.update.title,
				syllabusId:props.update.syllabusId,
				advLessonType:props.update.advLessonType,
				defaultNeedEvaluation:props.update.defaultNeedEvaluation,
			}
		);
		
		const isDiff = () => {
			if (rawCurData.title != updateData.title || rawCurData.syllabusId != updateData.syllabusId 
				|| rawCurData.advLessonType != updateData.advLessonType
				|| rawCurData.defaultNeedEvaluation != updateData.defaultNeedEvaluation
				) {
				return true;
			}
			return false;
		}
		
		return (
			<div className={show ? styles['modal'] : styles['modal-hide']}>
				<div className={styles['modal-content-wrapper']}>
					{(!rawCurData.tutorCourseId) && (<div className={styles['modal-content-header']}>Create <span className={styles['span-red']}>New</span> Tutor Course<span className={styles['span-bold']}>{tutorId}</span></div>)}
					{(rawCurData.tutorCourseId) && (<div className={styles['modal-content-header']}>Edit Tutor Course ({rawCurData.tutorCourseId})</div>)}
					<div className={styles['modal-content-detail']}>
						<div>
							<div className={styles['span-bold']}>Title </div>
							<div className="input-holder">
								<Form.Control type="text" value={updateData.title} 
									onChange={
										e => { 
											setUpdateData((prev)=>({...prev, ['title']:e.target.value}));
										}
									} 
								/>
							</div>
						</div>
						<div>
							<div className={styles['span-bold']}>Syllabus </div>
							<div className="input-holder">
								<Form.Select value={updateData.syllabusId} onChange={(e)=>{
										setUpdateData((prev)=>({...prev, ['syllabusId']:e.target.value}));
										}}>
										{syllabusData.map((o) => {
											return (
												<option key={o.sid} value={o.sid}>{o.sid} - {o.codeId} - {o.rcLevel}</option>
											)
										})}
								</Form.Select>
							</div>
						</div>
						<div>
							<div className={styles['span-bold']}>Advanced Type </div>
							<div className="input-holder">
								<Form.Select value={updateData.advLessonType} onChange={(e)=>{
										setUpdateData((prev)=>({...prev, ['advLessonType']:e.target.value}));
										
										}}>
										<option value='PDF'>PDF</option>
										<option value='WRITING-ENG-A'>WRITING-ENG-A</option>
										<option value='WRITING-ENG-B'>WRITING-ENG-B</option>
										<option value='WRITING-CHI-A'>WRITING-CHI-A</option>
										<option value='WRITING-CHI-B'>WRITING-CHI-B</option>
								</Form.Select>
							</div>
						</div>
						<div>
							<div className={styles['span-bold']}>Default evaluation (Only affect zoom classes not yet created)</div>
							<div className="input-holder">
								<CheckboxSmall label={""} isChecked = {(updateData.defaultNeedEvaluation == true) ? true : false} changeAction={() => {
									let d = (updateData.defaultNeedEvaluation == true) ? false : true;
									
									setUpdateData((prev)=>({...prev, ['defaultNeedEvaluation']:d}));
								}} />
							</div>
						</div>
						
						<div className={styles['modal-confirm']}>
							
							{(!rawCurData.tutorCourseId) && (
								<div className={(isDiff() ? "general-red-btn general-red-btn-default" : "general-btn-disabled")}
									onClick={()=>createTutorCourse(tutorId, updateData)}							
								>Create!!</div>
							)}
							{(rawCurData.tutorCourseId) && (
								<div className={(isDiff() ? "general-red-btn general-red-btn-default" : "general-btn-disabled")}
									onClick={()=>updateTutorCourse(rawCurData.tutorCourseId, updateData)}							
								>confirm & update</div>
							)}
						
						
							
						</div>
					</div>
					
				</div>
				<div className={styles['modal-backdrop']} onClick={()=>{ setShow(false)}}/>
			</div>);
	}
	

	return (
		<div id="container">
			<TutorCourseModal raw={rawUpdateData} update={updateData}/>
			
		
		
			<div>
				<div className={styles['detail-holder']} style={{alignItems:"start", gap:"10px"}}>
					<Image className={styles['thumbnail-path']} fluid
						src={`${rawData.profilePic}`} rounded />			
					<div>
						<TutorDetail tutorId={tutorId}/>													
													
													
													{/*
						<div>Tutor id: {tutorId}</div>
						<div>name: {rawData.displayName}</div>
						<div>username: {rawData.username}</div>
						
*/}
					</div>
					
						<MyTooltip msg={"&lt;page&gt;" +
													"tutor.js<br/><br/>" +
													"&lt;components&gt;<br/>" +
													"OneOnOne.js<br/>" + 
													"RegClass.js<br/>" + 
													"TutorDetail.js<br/>"} /> 
					{(toggleStatus == 3) && (<div>
					
							<div className="general-red-btn general-red-btn-default"
								onClick={()=>{
									setUpdateRawData({id:null, title:"",syllabusId:1});
									setUpdateData({id:null, title:"",syllabusId:1});
									setShow(true);
									}}							
							>Create New Tutor Course</div>
					</div>)}
				</div>
				
				<div >
					<li className={styles.toggleOptionHolder}>
						<ul className={(toggleStatus == 1) ? styles.toggleOptionOn : ""} onClick={()=>{setToggleStatus(1); setGeneralStorage('tutorPanelToggle', 1);}}>1-on-1</ul>
						<ul className={(toggleStatus == 2) ? styles.toggleOptionOn : ""} onClick={()=>{setToggleStatus(2); setGeneralStorage('tutorPanelToggle', 2);}}>Class</ul>
						<ul className={(toggleStatus == 3) ? styles.toggleOptionOn : ""} onClick={()=>{setToggleStatus(3); setGeneralStorage('tutorPanelToggle', 3);}}>tutor course</ul>
					</li>
				</div>
				
				{(toggleStatus == 1 && tutorGroups) && (<OneOnOne tutorId={tutorId} tutorGroups={tutorGroups}/>)
				}
				
				
				{(toggleStatus == 2) && (<RegClass tutorId={tutorId} />)
				}
				
				
				
				{
					
					(toggleStatus == 3) && (<div className={styles['tutor-course-list']}>
					<div className={styles['tutor-course-list-holder']}>
						{
							rawData.tutorCourses.map(v=>(
								<div key={v.id} className={styles['tutor-course-obj']}>
									<div className={styles['tutor-course-obj-left-holder']}>
										<div className={styles['tutor-course-obj-title']}>
											<span className={styles['span-bold']}>TCid</span> {v.id} <span className={styles['span-light']}> &#9632; {v.title}</span>
										</div>
										
										<div className={styles['obj-syllabus']}>
											<div>
												<span className={styles['span-bold']}>Sid</span> {v.syllabusId}  
											</div>
											<div>
												{v.advLessonType}
											</div>
											<div className={styles['edit-icon-holder']} onClick={()=>{setUpdateRawData(v);setUpdateData(v);setShow(true);}}>
												<img className={styles['edit-icon']} src={edit} alt="icon"/>
											</div>
										</div>
									</div>
									
									<div className={styles['obj-lesson']}>
										<div className={styles['obj-lesson-first-row']}>
											<div>
												<div><span className={styles['span-bold']}>Latest Zoom</span></div>
												<div className={styles['span-light']}>{v.latestZoomTitle}</div>
												<div>{modifiedDate(v.latestZoomStartDate)}</div>
											</div>
											<div><SmallCalendar date={v.latestZoomStartDate}/></div>
										</div>
									</div>
								</div>
							))
						}
					</div>
					<div className={styles['tutor-course-list-holder']}>
						{
							rawData.tutorCoursesNoZoom.map(v=>(
								<div key={v.id}  className={styles['tutor-course-obj']}>
									<div className={styles['tutor-course-obj-left-holder']}>
										<div className={styles['tutor-course-obj-title']}>
											<span className={styles['span-bold']}>TCid</span> {v.id} <span className={styles['span-light']}> &#9632; {v.title}</span>
										</div>
										
										<div className={styles['obj-syllabus']}>
											<div>
												<span className={styles['span-bold']}>Sid</span> {v.syllabusId}					
											</div>
											<div>
												{v.advLessonType}
											</div>
											<div className={styles['edit-icon-holder']} onClick={()=>{setUpdateRawData(v);setUpdateData(v);setShow(true);}}>
												<img className={styles['edit-icon']} src={edit} alt="icon"/>
											</div>
										</div>
									</div>
									
									<div className={styles['obj-lesson']}>
										<span className={styles['span-bold']}>Latest Zoom</span>
										<div className={styles['span-light']}>{v.latestZoomTitle}</div>
										<div>{modifiedDate(v.latestZoomStartDate)}</div>
									</div>
								</div>
							))
						}
					</div>
				</div>)
				
				}
				
			</div>
				
		</div>
	);
}